import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=304a9ab2&scoped=true"
import script from "./MiPerfil.vue?vue&type=script&lang=js"
export * from "./MiPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a9ab2",
  null
  
)

export default component.exports